/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PetBreedSizeModel } from './PetBreedSizeModel';
import {
    PetBreedSizeModelFromJSON,
    PetBreedSizeModelFromJSONTyped,
    PetBreedSizeModelToJSON,
} from './PetBreedSizeModel';
import type { PetTypeReferenceModel } from './PetTypeReferenceModel';
import {
    PetTypeReferenceModelFromJSON,
    PetTypeReferenceModelFromJSONTyped,
    PetTypeReferenceModelToJSON,
} from './PetTypeReferenceModel';

/**
 * 
 * @export
 * @interface PetBreedReferenceModel
 */
export interface PetBreedReferenceModel {
    /**
     * 
     * @type {number}
     * @memberof PetBreedReferenceModel
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PetBreedReferenceModel
     */
    name: string;
    /**
     * 
     * @type {PetBreedSizeModel}
     * @memberof PetBreedReferenceModel
     */
    size: PetBreedSizeModel;
    /**
     * 
     * @type {PetTypeReferenceModel}
     * @memberof PetBreedReferenceModel
     */
    type: PetTypeReferenceModel;
}

/**
 * Check if a given object implements the PetBreedReferenceModel interface.
 */
export function instanceOfPetBreedReferenceModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "size" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function PetBreedReferenceModelFromJSON(json: any): PetBreedReferenceModel {
    return PetBreedReferenceModelFromJSONTyped(json, false);
}

export function PetBreedReferenceModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetBreedReferenceModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'size': PetBreedSizeModelFromJSON(json['size']),
        'type': PetTypeReferenceModelFromJSON(json['type']),
    };
}

export function PetBreedReferenceModelToJSON(value?: PetBreedReferenceModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'size': PetBreedSizeModelToJSON(value.size),
        'type': PetTypeReferenceModelToJSON(value.type),
    };
}

